import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  event: {
    backgroundColor: theme.palette.primary.main,
    border: "none",
  },
}));
